
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { blogPosts } from '@/components/blog/blogData';
import BlogListing from '@/components/blog/BlogListing';
import BlogDetailView from '@/components/blog/BlogDetailView';
import { useBlogState } from '@/hooks/useBlogState';
import SEOMetadata from '@/components/common/SEOMetadata';

const Blog: React.FC = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const postId = searchParams.get('post');
  
  const {
    selectedPost,
    isLoading,
    searchQuery,
    filteredPosts,
    safeBlogPosts,
    handlePostClick,
    handleBackClick,
    handleSearchChange,
    handleClearSearch,
  } = useBlogState(blogPosts);

  // Create canonical URL
  const baseUrl = "https://catsabouttowntours.com";
  const canonicalUrl = selectedPost 
    ? `${baseUrl}/blog?post=${selectedPost.id}` 
    : `${baseUrl}/blog`;

  return (
    <div className="min-h-screen pt-20">
      {selectedPost ? (
        <SEOMetadata
          title={selectedPost.title}
          description={selectedPost.excerpt}
          canonicalUrl={canonicalUrl}
          ogImage={selectedPost.image}
          ogType="article"
          keywords={selectedPost.tags}
        />
      ) : (
        <SEOMetadata
          title="Blog - Cats About Town Walking Tours"
          description="Explore cat history in NYC with our blog. Latest stories about feline-focused walking tours, NYC's historic cats, and more."
          canonicalUrl={canonicalUrl}
          keywords={["NYC cat blog", "cat history stories", "feline history NYC", "cat walking tours blog"]}
        />
      )}

      {isLoading ? (
        <div className="container mx-auto px-4 py-12 text-center">
          <div role="status" aria-live="polite">
            <p className="text-gray-600">Loading...</p>
          </div>
        </div>
      ) : selectedPost ? (
        <BlogDetailView
          post={selectedPost}
          onBackClick={handleBackClick}
          relatedPosts={safeBlogPosts}
        />
      ) : (
        <BlogListing
          blogPosts={safeBlogPosts}
          searchQuery={searchQuery}
          filteredPosts={filteredPosts}
          onSearchChange={handleSearchChange}
          onPostClick={handlePostClick}
          onClearSearch={handleClearSearch}
        />
      )}
    </div>
  );
};

export default Blog;
